import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import { formatDistributionCenterName } from '@/utils/formatters'
import {
  formatDeliveryDate,
  type DetailLeafRow,
} from './inboundFlowReportMockData'

interface Props {
  rows: DetailLeafRow[]
}

function sum(rows: DetailLeafRow[], selector: (row: DetailLeafRow) => number) {
  return rows.reduce((acc, row) => acc + selector(row), 0)
}

export function InboundDetailViewTable({ rows }: Props) {
  const totals = {
    cartons: sum(rows, r => r.cartons),
    costDollars: sum(rows, r => r.costDollars),
    cubicFeet: sum(rows, r => r.cubicFeet),
    weightLbs: sum(rows, r => r.weightLbs),
    containers: sum(rows, r => r.containers),
  }

  return (
    <div className="max-h-[640px] overflow-auto rounded-lg border border-border bg-white shadow-sm">
      <Table>
        <TableHeader className="sticky top-0 z-10 bg-white">
          <TableRow className="hover:bg-transparent">
            <TableHead>source</TableHead>
            <TableHead>DC</TableHead>
            <TableHead>Order No</TableHead>
            <TableHead>SKU</TableHead>
            <TableHead>
              Estimated DC delivery date{' '}
              <span className="text-[9px] text-muted-foreground">▲</span>
            </TableHead>
            <TableHead className="text-right">Cartons</TableHead>
            <TableHead className="text-right">Cost dollars</TableHead>
            <TableHead className="text-right">Cubic feet</TableHead>
            <TableHead className="text-right">Weight (lb)</TableHead>
            <TableHead className="text-right">Containers</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {rows.map(row => (
            <TableRow key={row.id}>
              <TableCell>{row.source}</TableCell>
              <TableCell>{formatDistributionCenterName(row.dc)}</TableCell>
              <TableCell>{row.orderNo}</TableCell>
              <TableCell>{row.sku}</TableCell>
              <TableCell className="tabular-nums">
                {formatDeliveryDate(row.estimatedDcDeliveryDate)}
              </TableCell>
              <TableCell className="text-right tabular-nums">
                {row.cartons.toLocaleString('en-US')}
              </TableCell>
              <TableCell className="text-right tabular-nums">
                ${row.costDollars.toLocaleString('en-US')}
              </TableCell>
              <TableCell className="text-right tabular-nums">
                {row.cubicFeet.toLocaleString('en-US')}
              </TableCell>
              <TableCell className="text-right tabular-nums">
                {row.weightLbs.toLocaleString('en-US')}
              </TableCell>
              <TableCell className="text-right tabular-nums">
                {row.containers.toLocaleString('en-US')}
              </TableCell>
            </TableRow>
          ))}
          <TableRow className="border-t-2 border-border bg-muted/30 font-semibold hover:bg-muted/40">
            <TableCell className="font-semibold">Total</TableCell>
            <TableCell />
            <TableCell />
            <TableCell />
            <TableCell />
            <TableCell className="text-right tabular-nums font-semibold">
              {totals.cartons.toLocaleString('en-US')}
            </TableCell>
            <TableCell className="text-right tabular-nums font-semibold">
              ${totals.costDollars.toLocaleString('en-US')}
            </TableCell>
            <TableCell className="text-right tabular-nums font-semibold">
              {totals.cubicFeet.toLocaleString('en-US')}
            </TableCell>
            <TableCell className="text-right tabular-nums font-semibold">
              {totals.weightLbs.toLocaleString('en-US')}
            </TableCell>
            <TableCell className="text-right tabular-nums font-semibold">
              {totals.containers.toLocaleString('en-US')}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </div>
  )
}
